(function($) {

$.fn.SocialAccounts = function(options, callback) {

    var opts = $.extend({}, $.fn.SocialAccounts.defaults, options);
	
	// Mapping certain social network names to specially formatted versions
	var networkNameMapping = {
		'twitter': 'X',
		'linkedin': 'LinkedIn',
		'youtube': 'YouTube'
	};
	
	// Function to capitalize the first letter of a string
	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	// Function to reformat social network names
	function formatSocialNetworkName(name) {
		// Convert name to lowercase
		// - Doing this as a precaution just to make sure names are standardized.
		// - Right now, our json data is already returning the network name in all lowercase.
		var lowercaseName = name.toLowerCase();
	
		// Check if there's a special formatting for this network
		if (networkNameMapping[lowercaseName]) {
			return networkNameMapping[lowercaseName];
		}
	
		// If no special formatting, capitalize the first letter
		return capitalizeFirstLetter(lowercaseName);
	}

    $(this).each(function(){
        var obj = $(this);
        if(obj.attr('data-departments') == "" || obj.attr('data-departments') == null){
	        return;
        }else{
	        construct(obj);
        }
        
        if(callback !== undefined && $.isFunction(callback)){
            callback.call(this, obj);
        }
    });
    
    function construct(obj)
    {
    	obj.empty();
		var deptId = obj.attr('data-departments');
		var showTitle = obj.attr('data-enettitle') === 'true';
		var hideAccountName = obj.attr('data-hideaccountname') === 'true';
		var isLegacy = obj.attr('data-legacy') === undefined ? true : obj.attr('data-legacy');
		var loading = $('<p>Loading...</p>');
		
		obj.append(loading);
		
		console.log(elon_url.uri + 'wp-json/news/v1/feed/social?isLegacy=' + isLegacy + '&departmentIds=' + deptId);
		
				
		$.getJSON(elon_url.uri + 'wp-json/news/v1/feed/social?isLegacy=' + isLegacy + '&departmentIds=' + deptId, function(data) { // need to remove https://www.elon.edu/ when taking this live. 
			
			loading.remove();			
			
			$.each(data, function(key, department) {
				
				console.log(department);
				var wrap = $('<div class="individual-social-account"></div>');
				
				var deptName = department.Name;

				if (showTitle === true) {
					wrap.append('<p class="social-accounts-title">' + deptName + '</p>');
				}
				
				var list = $('<ul></ul>');
								
				$.each(department.ExtAccts, function(key, extAcct){
					
					var item = $('<li></li>');

					populateItem(item, department, extAcct, hideAccountName);
					
					list.append(item);
				
				});
				
				wrap.append(list);
				
				obj.append(wrap);
			});
			
			$(document).trigger('navChanged'); // this method might change the size of the sidebar its in, so trigger this so that StickyNav can reset its height
		});
    }
    
    function populateItem(item, department, extAcct, hideAccountName)
	{
		var srHelper = department.Name + ' on ';
		
		var formattedAcctName = formatSocialNetworkName(extAcct.Name);
		
		if (extAcct.Name == 'Blog')
		{
			srHelper = department.Name + ' ';
		}

		item.addClass(extAcct.Name.replace('+','').toLowerCase());
		
		var link = $('<a href="' + extAcct.Url + '" target="_blank"></a>');
		
		item.append(link);
		
		if (hideAccountName === false) {
			link.append('<span><span class="sr-only">' + srHelper + '</span>' + formattedAcctName + '</span>');
		} else {
			link.append('<span class="sr-only">' + srHelper + formattedAcctName + '</span>');
		}
	}
	
	return this;
};

$.fn.SocialAccounts.defaults = {
    myString: 'the default value',
    myBool: false
};

function debug(message) {
    if(typeof(console) !== 'undefined' && console !== null) {
        console.log(message);
    }
}

})(jQuery);